import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Car, CalendarClock, Handshake, Users, Star, Settings, Bot, LogOut, Menu, X, FileSpreadsheet, Camera } from "lucide-react";
import Logo from "../components/Logo";
import api from "../lib/api";

const NAV = [
  { to: "/admin", label: "Dashboard", Icon: LayoutDashboard, end: true },
  { to: "/admin/inventory", label: "Inventory", Icon: Car },
  { to: "/admin/imports/cartrade", label: "Import", Icon: FileSpreadsheet },
  { to: "/admin/imports/photos", label: "Photo Import", Icon: Camera },
  { to: "/admin/test-drives", label: "Test Drives", Icon: CalendarClock },
  { to: "/admin/sell-leads", label: "Sell Leads", Icon: Handshake },
  { to: "/admin/leads", label: "Enquiries", Icon: Users },
  { to: "/admin/reviews", label: "Reviews", Icon: Star },
  { to: "/admin/settings", label: "Settings", Icon: Settings },
  { to: "/admin/ai", label: "AI Assistant", Icon: Bot },
];

const AdminLayout = () => {
  const nav = useNavigate();
  const [admin, setAdmin] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("autobahn_admin_token");
    if (!token) { nav("/admin/login"); return; }
    api.get("/auth/me").then((r) => setAdmin(r.data)).catch(() => nav("/admin/login"));
  }, [nav]);

  const logout = () => {
    localStorage.removeItem("autobahn_admin_token");
    localStorage.removeItem("autobahn_admin_user");
    nav("/admin/login");
  };

  if (!admin) return <div className="min-h-screen bg-[#F7F6F3] flex items-center justify-center text-sm text-[#242424]/60">Loading admin…</div>;

  return (
    <div className="min-h-screen bg-[#F7F6F3] text-[#242424] flex" data-testid="admin-shell">
      <aside className={`fixed lg:sticky top-0 h-screen w-64 bg-[#111111] text-white flex flex-col z-40 transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-5 border-b border-white/10 flex items-center justify-between">
          <Link to="/admin" className="flex items-center"><Logo className="h-9 w-9" showWordmark invert /></Link>
          <button onClick={() => setOpen(false)} className="lg:hidden text-white/70"><X size={18} /></button>
        </div>
        <nav className="flex-1 py-4">
          {NAV.map(({ to, label, Icon, end }) => (
            <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)}
              className={({ isActive }) => `flex items-center gap-3 px-5 py-3 text-sm transition-colors ${isActive ? "bg-[#7A1519] text-white" : "text-white/70 hover:bg-white/5 hover:text-white"}`}
              data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g,'-')}`}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/10 p-5">
          <div className="text-xs text-white/50">Signed in as</div>
          <div className="text-sm mt-1 truncate">{admin?.email}</div>
          <button onClick={logout} className="mt-4 w-full inline-flex items-center gap-2 border border-white/20 text-white/80 hover:bg-white/10 rounded-sm py-2 justify-center text-xs" data-testid="admin-logout"><LogOut size={12} /> Logout</button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <div className="lg:hidden sticky top-0 z-30 bg-white border-b hairline px-4 h-14 flex items-center justify-between">
          <button onClick={() => setOpen(true)} className="p-2"><Menu size={18} /></button>
          <Logo className="h-8 w-8" showWordmark />
          <div className="w-8" />
        </div>
        <main className="p-6 md:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
